/** @format */

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const SEND_EMAIL = "SEND_EMAIL";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const GET_FORMS_SUCCESS = "GET_FORMS_SUCCESS";
export const GET_FORM_SUCCESS = "GET_FORM_SUCCESS";
export const GET_FORMS_FAIL = "GET_FORMS_FAIL";
export const GET_QUESTIONS_SUCCESS = "GET_QUESTIONS_SUCCESS";
export const GET_QUESTIONS_FAIL = "GET_QUESTIONS_FAIL";

export const GET_ANSWERS_SUCCESS = "GET_ANSWERS_SUCCESS";
export const GET_ANSWER_SUCCESS = "GET_ANSWER_SUCCESS";
export const GET_ANSWERS_FAIL = "GET_ANSWERS_FAIL";

export const GET_PATIENTS_SUCCESS = "GET_PATIENTS_SUCCESS";
export const GET_PATIENT_SUCCESS = "GET_PATIENT_SUCCESS";
export const GET_PATIENTS_FAIL = "GET_PATIENTS_FAIL";
export const GET_PATIENT_FAIL = "GET_PATIENT_FAIL";

export const GET_PATIENTS_DOCTOR_SUCCESS = "GET_PATIENTS_DOCTOR_SUCCESS";
export const GET_PATIENTS_DOCTOR_FAIL = "GET_PATIENTS_DOCTOR_FAIL";

export const GET_DOCTORS_SUCCESS = "GET_DOCTORS_SUCCESS";
export const GET_DOCTOR_SUCCESS = "GET_DOCTOR_SUCCESS";
export const GET_DOCTORS_FAIL = "GET_DOCTORS_FAIL";
export const GET_DOCTOR_FAIL = "GET_DOCTOR_FAIL";
export const SAVE_DOCTOR_SUCCESS = "SAVE_DOCTOR_SUCCESS";
export const SAVE_DOCTOR_FAIL = "SAVE_DOCTOR_FAIL";
export const ASSIGN_DOCTOR_SUCCESS = "ASSIGN_DOCTOR_SUCCESS";
export const ASSIGN_DOCTOR_FAIL = "ASSIGN_DOCTOR_FAIL";

export const GET_MESSAGES_PATIENT_SUCCESS = "GET_MESSAGES_PATIENT_SUCCESS";
export const GET_MESSAGES_PATIENT_FAIL = "GET_MESSAGES_PATIENT_FAIL";
export const SEND_MESSAGE_PATIENT_SUCCESS = "SEND_MESSAGE_PATIENT_SUCCESS";

export const GET_HOSPITALS_SUCCESS = "GET_HOSPITALS_SUCCESS";
export const GET_HOSPITALS_FAIL = "GET_HOSPITALS_FAIL";
export const SAVE_HOSPITAL_SUCCESS = "SAVE_HOSPITAL_SUCCESS";
export const SAVE_HOSPITAL_FAIL = "SAVE_HOSPITAL_FAIL";
export const GET_HOSPITAL_SUCCESS = "GET_HOSPITALS_SUCCESS";
export const GET_HOSPITAL_FAIL = "GET_HOSPITALS_FAIL";

export const GET_ALL_DOCTORS_SUCCESS = "GET_ALL_DOCTORS_SUCCESS";
export const GET_ALL_DOCTORS_FAIL = "GET_ALL_DOCTORS_FAIL";

export const GET_HOSPITALS_DOCTOR_SUCCESS = "GET_HOSPITALS_DOCTOR_SUCCESS";
export const GET_HOSPITALS_DOCTOR_FAIL = "GET_HOSPITALS_DOCTOR_FAIL";
export const GET_HOSPITAL_DOCTOR_SUCCESS = "GET_HOSPITAL_DOCTOR_SUCCESS";
export const GET_HOSPITAL_DOCTOR_FAIL = "GET_HOSPITAL_DOCTOR_FAIL";

export const GET_COORDINATORS_SUCCESS = "GET_COORDINATORS_SUCCESS";
export const GET_COORDINATORS_FAIL = "GET_COORDINATORS_FAIL";

export const GET_DISTRICTS_SUCCESS = "GET_DISTRICTS_SUCCESS";
export const GET_DISTRICTS_FAIL = "GET_DISTRICTS_FAIL";

export const GET_PROVINCES_SUCCESS = "GET_PROVINCES_SUCCESS";
export const GET_PROVINCES_FAIL = "GET_PROVINCES_FAIL";

export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS";
export const GET_ROLES_FAIL = "GET_ROLES_FAIL";

export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";
